import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'

const SocialLinks = ({ label = '', icons = [], speakerProfileData = [], speaker = {} }) => {
  const newIcon = {}

  let validSocials = icons?.length

  icons?.some((icon, i) => {
    if (icon.iconLable.includes('Website') && icons[i]?.link == undefined)
      validSocials = icons?.length - 1
  })

  Object.keys(speakerProfileData || {}).map((key) => {
    const str = key.includes('1') ? key.substring(0, key.length - 1) : key
    if (
      icons.some((obj) => obj.iconLable?.replace(/\s/g, '')?.toLowerCase() === str?.toLowerCase())
    ) {
      newIcon[str?.toLowerCase()] = speakerProfileData[key]
    }
  })

  return (
    <>
      <div className=" text-lg tagline-font lg:pt-3 pb-3 font-bold uppercase">
        {' '}
        {label === 'Speaker Social Links' ? 'Socials' : 'UTA SOCIALS'}
      </div>
      <div
        className={classNames(
          'maxSm:flex lg:block maxSm:gap-x-[22px] gap-x-10 sm:gap-x-16',
          validSocials >= 4 && 'socialsColumns'
        )}
      >
        {(label === 'Speaker Social Links' ? icons : icons).map((data, index) => {
          return (
            <div key={index} className="mb-3">
              {data.link && (
                <Link href={data.link} legacyBehavior>
                  <a
                    target="_blank"
                    aria-label={`${speaker.name} on ${data.iconLable}`}
                    className="group"
                  >
                    <div className="text-[#B4B4B4] text-xl maxSm:text-[27px] inline-block mr-5 maxMob:mr-0 group-hover:text-white">
                      {data.icon}
                    </div>
                    <div
                      className={`inline-block text-sm maxSm:invisible maxSm:absolute relative bottom-1.5 visible group-hover:underline underline-offset-2`}
                    >
                      {data.iconLable}
                    </div>
                  </a>
                </Link>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}

export default SocialLinks
